/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { useDataContext } from '../context';
import { useCookies } from 'react-cookie';

const API_URL = import.meta.env.VITE_API_URL;

function GetFolderList() { // เปลี่ยนชื่อจาก Token เป็น GetFolderList
    const { data, setData } = useDataContext();
    const [cookies] = useCookies(['token']);

    // ตัวกันยิงซ้ำ
    const hasFetched = useRef(false);

    useEffect(() => {
        // 1. ถ้ามีข้อมูลแล้ว ไม่ต้องโหลด
        if (data.folderInHr && data.folderInHr.length > 0) {
            return;
        }

        // 2. ถ้ายังไม่มี Token ไม่ต้องยิง (รอจนกว่า Token จะมา)
        if (!cookies.token) {
            return;
        }

        // 3. กันยิงซ้ำ
        if (hasFetched.current) return;

        const fetchData = async () => {
            hasFetched.current = true;
            try {
                const myHeaders = new Headers();
                myHeaders.append("authorization", cookies.token);

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    redirect: "follow"
                };

                const response = await fetch(`${API_URL}/msGetFolderList`, requestOptions);
                const result = await response.json();

                setData(prevData => ({
                    ...prevData, 
                    folderInHr: result?.data?.value || []
                }));

            } catch (error) {
                console.error("Error fetching folder list:", error);
                hasFetched.current = false;
            }
        };

        fetchData();

    }, [cookies.token]); // รันใหม่เมื่อ Token เปลี่ยน (เช่น เพิ่ง Login เสร็จ)
    
  return null;
}

export default GetFolderList;